import { httpRequest } from "../../http";

export type CreateFolderPayload = {
    parent_id?: number | null;
    type: "folder" | "collection";
    name: string;
    sequence_order?: number;
};

export class CommandCreateFolder {
    async run(organizationId: number, payload: CreateFolderPayload) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${organizationId}/folders/`;
        try {
            const response = await httpRequest<any>(url, { method: "POST", body: payload });
            if (response) {
                return response;
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    }
}
